import { Route, NavigationGuardNext } from "vue-router";
import { getModule } from "vuex-module-decorators";
import MasterPlanState from "@/modules/master-plan";
import { Paths } from "@/util/paths";
import { fmtMsg } from "commonui";
import { BreadCrumbMenuLocale } from "@/locales/localeid";
import { AppBreadCrumbModule } from "@/modules/bread-crumb";

export const MasterPlanResolver = async function (to: Route, from: Route, next: NavigationGuardNext) {
	const masterPlanModule = getModule(MasterPlanState);
	const actions: Promise<void>[] = [];
	const { versionGroupId, lessonPlanVersionId, unitId, methodology } = to.params;
	actions.push(
		masterPlanModule.fetchLessonPlans({
			versionGroupId,
			lessonPlanVersionId,
			unitId: parseInt(unitId, 10),
			methodology: parseInt(methodology, 10)
		})
	);

	const appBreadCrumbModule = AppBreadCrumbModule;
	const appRoutes = [
		{
			path: Paths.LessonPlanVersion,
			breadcrumbName: fmtMsg(BreadCrumbMenuLocale.BreadCrumbMenuLPV),
			params: {},
			queryParams: {}
		}
	];

	if (versionGroupId && lessonPlanVersionId && unitId && methodology) {
		appRoutes.push({
			path: Paths.LessonPlanListWithParams,
			breadcrumbName: fmtMsg(BreadCrumbMenuLocale.BreadCrumbMenuLPList),
			params: {
				versionGroupId,
				lessonPlanVersionId,
				methodology: parseInt(methodology, 10)
			},
			queryParams: {
				unitId: parseInt(unitId, 10),
			}
		});
		appRoutes.push({
			path: Paths.MasterPlan,
			breadcrumbName: fmtMsg(BreadCrumbMenuLocale.BreadCrumbMenuMasterPlan),
			params: {
				versionGroupId,
				lessonPlanVersionId,
				unitId: parseInt(unitId, 10),
				methodology: parseInt(methodology, 10)
			},
			queryParams: {}
		});
	}
	appBreadCrumbModule.setBreadCrumbRoutes(appRoutes);

	await Promise.all(actions);
	next();
};
